import instance from '../../instance';
import getLiveElement from '../../accessors/get-live-element';
import bindings from '../../injections/bindings';

const getNotDisabledLiveElement = (element) => {
  const liveElementId = instance.driver.referenceMap.getClosestReferenceId(element);
  const liveElement = getLiveElement(liveElementId);

  if (bindings.disable.isDisabledNode(liveElement)) {
    const liveParentElementId = instance.driver.referenceMap.getParentReferenceId(liveElement);
    const liveParentElement = getLiveElement(liveParentElementId);
    return getNotDisabledLiveElement(liveParentElement);
  }

  return { element: liveElement, id: liveElementId };
};

export default getNotDisabledLiveElement;
